// @ts-nocheck
import { headerStyles } from "@insite/content-library/Widgets/MyListsDetails/MyListsDetailsHeader";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import { mediaOptions } from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

Object.assign(headerStyles, {
    container: {
        gap: 15,
        css: css`
            padding: 1em;
            background-color: ${getColor("common.accent")};

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            padding: 0;
                            background-color: transparent;
                        `,
                    ],
                    mediaOptions.min,
                )}
        `,
    },
    infoGridItem: {
        width: 12,
        css: css`
            justify-content: flex-start;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        css`
                            flex-direction: column;
                        `,
                    ],
                    mediaOptions.max,
                )}
        `,
    },
});
